import "./IndustryInsights.module.css";
import Header from "@/reusable_sections/Header";
import Intro from "./sections/Intro";
import Spotlight from "./sections/Spotlight";
import Articles from "./sections/Articles";
import Footer from "@/reusable_sections/Footer";
export default function IndustryInsightsPage() {
  return <div>
      <Header />
      <Intro />
      <Spotlight />
      <Articles />
      <Footer />
    </div>;
}